import React from 'react';

import { CardElement } from '@stripe/react-stripe-js';
import type { StripeCardElementChangeEvent } from '@stripe/stripe-js';

type Props = {
	onChange?: (event: StripeCardElementChangeEvent) => unknown;
	disabled?: boolean;
	onFocus?: () => void;
	onBlur?: () => void;
};

export const CardElementWrapper: React.FC<Props> = ({ onChange, disabled, onFocus, onBlur }) => {
	return (
		<CardElement
			options={{
				hidePostalCode: true,
				disableLink: true,
				hideIcon: true,
				disabled,
				style: { base: { fontSize: '16px' } },
			}}
			onChange={onChange}
			onFocus={onFocus}
			onBlur={onBlur}
		/>
	);
};
